import React, { Component } from 'react';
import { Tag } from 'antd';

class ProductSKUTag extends Component {

  handleDeleteBtnClick =(e)=> {
    e.preventDefault();
    const { tag, index, onClickDelete } = this.props || {};
    if (tag && onClickDelete) {
      onClickDelete(index, tag);
    }
  }

  render() {
    const { tag } = this.props || {};
    return (
        <Tag color="blue" closable onClose={this.handleDeleteBtnClick}>{ tag }</Tag>
    )
  }
}

export default ProductSKUTag;